import React from 'react';
import TimeLibrary from '../../libraries/Time';

/**
 * Distinct light design for BernExpo QR parking tickets. These are fully
 * digital (QR only, no slider) and must be easily identified as BernExpo
 * Parking + print cleanly. No code number is shown (per client).
 * @component
 */
export default ({ qrImage, opponent, gameDate, usedAt }) => {
  // Validity window with concrete dates: game day 16:00 → next day 04:00.
  const day = gameDate ? new Date(gameDate) : null;
  const nextDay = day ? new Date(day.getTime() + 24 * 60 * 60 * 1000) : null;
  const validity =
    day && nextDay
      ? `Gültig ab ${TimeLibrary.dayAndDate(gameDate)} 16:00 Uhr bis ${TimeLibrary.dayAndDate(
          nextDay.toISOString(),
        )} 04:00 Uhr.`
      : 'Gültig ab 16:00 Uhr am Spieltag bis 04:00 Uhr am Folgetag.';

  return (
    <div className="bernexpo-ticket">
      <div className="bernexpo-ticket-head">BERNEXPO PARKING</div>

      {qrImage && (
        <div className="bernexpo-ticket-qr">
          <img src={qrImage} alt="QR-Code" />
        </div>
      )}

      {/* Straight from the printed permit: BernExpo's barrier only lets you out
          if you drove in on the same permit. BernExpo-only by nature — the other
          lots have no barrier, so the warning would only confuse there. */}
      <div className="bernexpo-ticket-checkin">CHECK IN FIRST!</div>

      {/* The SCB MATCH block from the printed permit, drawn rather than shipped
          as an image: no asset exists for it, and it has to be wide and short
          instead of the near-square print proportions, which a bitmap would not
          survive being stretched into. */}
      <div className="bernexpo-ticket-match">
        <div className="bernexpo-ticket-match-scb">SCB</div>
        <div className="bernexpo-ticket-match-word">MATCH</div>
      </div>

      <div className="bernexpo-ticket-game">
        <strong>SC Bern{opponent ? ` – ${opponent}` : ''}</strong>
        {gameDate && (
          <span>
            {TimeLibrary.date(gameDate)}, {TimeLibrary.time(gameDate)} Uhr
          </span>
        )}
        <span>PostFinance Arena</span>
      </div>

      <div className="bernexpo-ticket-validity">{validity}</div>

      {!!usedAt && <div className="bernexpo-ticket-used">Bereits verwendet</div>}
    </div>
  );
};
